.manageTeamRoleSelect {
  display: flex;
  width: 100%;
}
